import { colors, IMTextArea } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const IMTextAreaStyled = styled(IMTextArea)`
  margin-bottom: 1rem;
  padding-bottom: 4rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
  flex-grow: 1;
`;
